import Image from "next/image";
import ratingsLogo from "../../assets/Images/rating.png";

import useSWR from "swr";
import { popUp } from "@/elements/PopUp/SEBIPopUp";
import TrialCountdownSection from "./TrialCountdown";
import { UserDetailProvider } from "@/contexts/UserDetailContext";
import { useContext, useEffect, useState } from "react";
import Actions from "@/elements/Actions";
import { BlackButton, ExploreMore } from "@/elements/Button/Button";
import { useRouter } from "next/router";
import axios from "axios";
import { Mixpanel } from "@/elements/Mixpanel";
import { AiOutlineInfoCircle } from "react-icons/ai";
import get_5_free_trades from "@/assets/get_5_free_trades.webp";

export default function ProAndPlusHeroSection({ homePage, isDark = false, onClick }) {
    const router = useRouter();

    const userDetail = useContext(UserDetailProvider);
    const handleClick = () => {
        Mixpanel.track("activate_protrial_clicked", {
            page: homePage ? "web_home" : "web_pro_page"
        });
        if (userDetail?.userData?.subscriptionState === "FREE") {
            axios
                .put(
                    `${process.env.apiBaseURL}/resources/user-subscription/activate-trial-v3`,
                    {},
                    {
                        headers: {
                            Authorization: `Bearer ${Actions.getCookie("auth_token")}`,
                            "device-name": Actions.getDeviceName(),
                            "device-id": Actions.generateUniqueDeviceID()
                        }
                    }
                )
                .then((res) => {
                    if (res.data?.data) {
                        let uD = {
                            ...userDetail?.userData,
                            planName: "Free trial",
                            subscriptionState: res.data?.data?.subscriptionState,
                            expiryDate: res.data?.data?.expiryDate
                        };
                        userDetail?.setUserData(uD);
                        Actions.setCookie("user_details", JSON.stringify(uD), 7);
                        FaceBook.track("StartTrial");
                    } else {
                        let uD = {
                            ...userDetail?.userData,
                            subscriptionState: "TRIAL_PRO_SUPER_EXPIRED"
                        };
                        userDetail?.setUserData(uD);
                        Actions.setCookie("user_details", JSON.stringify(uD), 7);
                        FaceBook.track("StartTrial");
                    }
                });
        } else {
            if (homePage) {
                router.push("/pro");
                setTimeout(() => {
                    userDetail?.inputRef?.current?.focus();
                }, 1000);
            } else {
                userDetail?.inputRef?.current?.focus();
            }
        }
    };

    return (
        <div
            id="Hero"
            className={
                homePage
                    ? "font-Inter overflow-hidden bg-gradient-to-b from-[#202020] to-[#202020] h-full relative"
                    : "font-Inter overflow-hidden h-full relative"
            }
        >
            <div className=" whitespace-nowrap pt-24 lg:px-8 max-w-screen-xl mx-auto gap-8">
                <div className=" flex flex-col  gap-5 mx-auto">
                    <div className="  font-Inter basis-full md:basis-7/12 flex flex-col content-center relative">
                        <span
                            className={`text-center text-2xl font-extrabold leading-[44px]  lg:text-3xl ${
                                !isDark ? "text-white" : "text-[#414141]"
                            }`}
                        >
                            India’s trusted
                        </span>
                        <span
                            className={`text-center text-2xl font-extrabold leading-[44px] lg:text-3xl ${
                                !isDark ? "text-white" : "text-[#414141]"
                            }`}
                        >
                            <span className="text-[#EF9400]">"Stock market"</span> advisory
                        </span>
                    </div>
                    <p className="text-center text-sm lg:text-3xl font-extrabold text-white">
                        Stocks<span className="mx-2">|</span>Futures<span className="mx-2">|</span>Options
                    </p>
                    {/* <div>
                        <p className="text-center text-xs lg:text-3xl font-bold text-white">SEBI Registered - INH000013776</p>
                        <div className=" flex justify-center items-center" onClick={() => popUp.open()}>
                            <p className="text-center text-[8px] lg:text-3xl font-semibold text-[#BCBCBC]" >Uniresearch, a wholly owned subsidiary of Univest</p>
                            <Image className="w-2 ml-1" src={infoIcon} alt='appAndPlay' />
                        </div> 
                    </div>*/}
                </div>
                {homePage && (
                    <img
                        src={get_5_free_trades.src}
                        alt="get_5_free_trades"
                        width={984}
                        height={552}
                        className="w-[calc(100%-32px)] mx-auto my-6"
                        onClick={handleClick}
                    />
                )}
                {userDetail?.userData?.subscriptionState === "TRIAL_PRO_SUPER" && !homePage ? (
                    <TrialCountdownSection className="px-4 pt-6" endTime={userDetail?.userData?.expiryDate} />
                ) : (
                    <div className="px-4" />
                )}
                <div className="flex items-center mx-4 lg:hidden">
                    <p className={`font-semibold text-base text-white`}>Powered by SEBI Reg. RA Uniresearch</p>
                    <AiOutlineInfoCircle
                        color="#FFFFFF"
                        className="text-[16px] ml-2 cursor-pointer"
                        onClick={(e) => {
                            popUp.open("uniresearch");
                        }}
                    />
                </div>

                <div className="mx-4 my-8">
                    {!userDetail?.userData?.subscriptionState ? (
                        <>
                            <BlackButton
                                text="Activate FREE Trial"
                                className="w-full py-2 my-6 proGradient text-black text-base font-bold"
                                onClick={onClick ?? handleClick}
                            />
                            <p
                                className="text-center text-[10px] lg:text-3xl font-semibold text-[#FFF]"
                                ref={userDetail.ref}
                            >
                                No payment / card required
                            </p>
                        </>
                    ) : (
                        homePage && (
                            <ExploreMore
                                className="lg:absolute lg:bottom-36 lg:left-8 text-white border-white w-40 lg:w-48 mt-8"
                                onClick={() => router.push("/user/log-in")}
                            />
                        )
                    )}
                </div>
            </div>
            {homePage ? (
                <div className={"h-14"} />
            ) : (
                <div className="mt-8 hidden lg:flex whitespace-nowrap justify-between items-center lg:gap-16 [background:var(--Questionnaire-background-color,linear-gradient(127deg,#DDF6FF_-31.48%,#FFEAEF_95.46%))] px-4 py-2 lg:px-20 lg:py-[16.333px] ">
                    <div className="flex items-center gap-2 lg:gap-4">
                        <p className="text-[color:var(--Neutral-900,#202020)] text-sm font-medium leading-6  lg:text-[28px] lg:font-semibold lg:leading-[49px]">
                            Trusted by
                        </p>
                        <p className="text-[color:var(--Neutral-900,#202020)] text-xl font-extrabold leading-8 lg:text-[40px] lg:font-extrabold lg:leading-[65.333px]">
                            40lakhs+ users
                        </p>
                    </div>
                    <Image className="w-[116px] h-[21px] lg:w-[260px] lg:h-[48px]" src={ratingsLogo} alt="demo" />
                </div>
            )}
        </div>
    );
}
